import { render, staticRenderFns } from "./ReceiptHeader.vue?vue&type=template&id=44a4673a&scoped=true&"
import script from "./ReceiptHeader.vue?vue&type=script&lang=ts&"
export * from "./ReceiptHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptHeader.vue?vue&type=style&index=0&id=44a4673a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a4673a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBar,VBtn,VIcon})
